
















































import { Vue, Component } from 'vue-property-decorator'
import store from 'src/assets/store'
import MenuButtonAdd from 'components/presenter/item/team/MenuButtonAdd.vue'
import ListItem from 'components/presenter/item/team/ListItem.vue'
import api from 'src/assets/api/gql'
import ItemShareTeam from 'src/graphql/item_share/ItemShareTeam.gql'
import { ItemShare, ItemShareRole } from 'src/graphql/types'

@Component({
  components: {
    MenuButtonAdd,
    ListItem
  }
})
export default class PagePresenterItemTeam extends Vue {
  ItemShareRole = ItemShareRole
  loading = false
  team: ItemShare[] = []

  get item () {
    return store.state.presenter.item
  }

  get members () {
    const members: Json = {}
    members[ ItemShareRole.Admin ] = []
    members[ ItemShareRole.Editor ] = []
    members[ ItemShareRole.Presenter ] = []
    for (const share of this.team) {
      members[ share.role ].push(share)
    }
    return members
  }

  refresh (done: () => void) {
    this.team = []
    done()
  }

  async load (index: number, done: (stop?: boolean) => void) {
    this.loading = true
    const { data: { itemShareTeam } } = await api.query({
      query: ItemShareTeam,
      variables: {
        id: this.item.id
      }
    })
    this.loading = false
    if (itemShareTeam) {
      this.team = itemShareTeam.nodes as ItemShare[]
    }
    done(true)
  }

  setTeamMember (member: ItemShare, newMember: ItemShare) {
    const memberIndex = this.team.indexOf(member)
    if (memberIndex === -1) {
      this.team.push(newMember)
    } else {
      this.team.splice(memberIndex, 1, newMember)
    }
  }

  removeTeamMember (member: ItemShare) {
    const memberIndex = this.team.indexOf(member)
    if (memberIndex !== -1) {
      this.team.splice(memberIndex, 1)
    }
  }
}
